 function b64toBlob (b64Data, contentType, sliceSize) {
    var byteCharacters = atob(b64Data), byteArrays = [], slice, byteNumbers, byteArray, blob;
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        slice = byteCharacters.slice(offset, offset + sliceSize);
        byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    blob = new Blob(byteArrays,{
        type: contentType
    });
    return blob;
}

const downloadConteudoBase64 = (nomeArquivo, conteudo) => {
    var contentType = 'application/octet-stream',
        blob = b64toBlob(conteudo, contentType),
        blob,
        blobUrl = URL.createObjectURL(blob);

    if (window.navigator.msSaveOrOpenBlob) {
        var fileData = [blob],
            blobObject = new Blob(fileData);

        window.navigator.msSaveOrOpenBlob(blobObject, nomeArquivo);
    } else {
        downloadFile(nomeArquivo, blobUrl);
    }
};

const downloadFile = (fileName, url) => {
    var decodedFileName;

    try {
        decodedFileName = decodeURIComponent(fileName);
    } catch (e) {
        decodedFileName = fileName;
    }

    if (needToForceDownload(decodedFileName)) {
        forceDownload(decodedFileName, url);
        return;
    }

    var link = document.createElement('a');

    link.setAttribute('download', decodedFileName);
    link.setAttribute('type', 'application/octet-stream');
    link.target = '_blank';
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

const needToForceDownload = (fileName) => {
    fileName = fileName.toLowerCase();

    return fileName.endsWith('.txt')  || 
           fileName.endsWith('.jpeg') || 
           fileName.endsWith('.jpg')  || 
           fileName.endsWith('.png')  || 
           fileName.endsWith('.bmp')  || 
           fileName.endsWith('.pdf')  || 
           fileName.endsWith('.html') || 
           fileName.endsWith('.json') || 
           fileName.endsWith('.pdf')  || 
           fileName.endsWith('.rem')  || 
           fileName.endsWith('.xml')  || 
           fileName.endsWith('.csv')  || 
           fileName.endsWith('.gif');
};

const forceDownload = (fileName, url) => {
    var xhr = new XMLHttpRequest;

    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.withCredentials = false;

    xhr.onload = function() {
        var urlCreator = window.URL || window.webkitURL,
            imageUrl = urlCreator.createObjectURL(this.response),
            link = document.createElement('a');

        link.href = imageUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    xhr.onerror = function() {
        var link = document.createElement('a');

        link.setAttribute('download', fileName);
        link.setAttribute('type', 'application/octet-stream');
        link.target = '_blank';
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    xhr.send();
}

export { downloadConteudoBase64, downloadFile, needToForceDownload, forceDownload };